import type { FaireProductEntity } from "../../entity_types/product";

export const p_fvtrfv3y4c: FaireProductEntity = {
  token: "p_fvtrfv3y4c",
  type: "product",
  name: "Matches - Sepia Floral",
  brandName: "HomArt",
  imageUrl:
    "https://cdn.faire.com/fastly/f6ff2576be7b51a0167ad5b107e22cc9ea53ae0872043155538baf01547ef54f.jpeg",
  priceDollars: 2.1,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/fdf7ee285a2df5d9a279fe53decc533f1d97f0f999a8f642e92ea75cd43e91e6.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
